import React from 'react';
import styled from 'styled-components';
import { ReactComponent as RetryIcon } from '../../svg/retry.svg';
import { ReactComponent as CopyIcon } from '../../svg/copy.svg';
import { ReactComponent as ThumbUp } from '../../svg/thumb-up.svg';
import { ReactComponent as ThumbUpEmpty } from '../../svg/thumb-up_empty.svg';
import { ReactComponent as ThumbDown } from '../../svg/thumb-down.svg';
import { ReactComponent as ThumbDownEmpty } from '../../svg/thumb-down_empty.svg';
import { ReactComponent as Flag } from '../../svg/flag.svg';
import { ReactComponent as FlagEmpty } from '../../svg/flag_empty.svg';

interface ActionButtonProps {
  onClick?: () => void;
  buttonType: 'retry' | 'copy' | 'thumbUp' | 'thumbUpEmpty' | 'thumbDown' | 'thumbDownEmpty' | 'flag' | 'flagEmpty';
  isActive?: boolean;
}

const StyledActionButton = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;
  color: ${({ theme }) => theme.colorPalette.turquoise.dark};

  &:hover {
    background-color: ${({ theme }) => theme.colorPalette.grey.grey1};
  }
`;

export const ActionButton: React.FC<ActionButtonProps> = ({ onClick, buttonType, isActive }) => {
  const renderIcon = () => {
    switch (buttonType) {
      case 'retry':
        return <RetryIcon width={16} height={16} />;
      case 'copy':
        return <CopyIcon width={14} height={16} />;
      case 'thumbUp':
        return isActive ? <ThumbUp width={16} height={18} /> : <ThumbUpEmpty width={16} height={18} />;
      case 'thumbDown':
        return isActive ? <ThumbDown width={16} height={18} /> : <ThumbDownEmpty width={16} height={18} />;
      case 'flag':
        return isActive ? <Flag width={14} height={20} /> : <FlagEmpty width={14} height={20} />;
      default:
        return null;
    }
  };

  return <StyledActionButton onClick={onClick}>{renderIcon()}</StyledActionButton>;
};
